import React from 'react';
import {Container, Typography} from "@mui/material";
import {css} from "@emotion/react";
import colorPalette from "../../../../styles/theme/colorPalette";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import LinkButton from "../../../atoms/LinkButton";

const MedicalNetBook = () => {
  return (
      <div css={wrapper}>
        <Container>
          <div css={{marginBottom: '32px'}}>
            <Typography variant={'h1'} css={mainTitle}>
              <span>メディカルネットブック</span>
            </Typography>
            <div css={subtitle}>
              疾病に関する分野で著名な医師・管理栄養士の先生に監修いただき、<br/>
              書店で販売されている家庭の医学さながらの<br/>
              信頼できる内容をあなたにお届けいたします。
            </div>
            <div css={btnWrapper}>
              <LinkButton
                  text={'詳しく見る'}
                  href={'https://m-netbook.mealtime.jp/?mt_top'}
                  maxWidth={"300px"}
                  hexColorCode={colorPalette.white}
                  endAdornment={ <ArrowRightIcon /> }
                  css={btnStyle}
              />
            </div>
          </div>
        </Container>
      </div>
  );
};

export default MedicalNetBook;

const wrapper = css`
  padding: 24px 0;
  background: ${colorPalette.primaryGradient.rgb};
  background: ${colorPalette.primaryGradient.gradient};
`

const mainTitle = css`
  font-weight: bold;
  color: white;
  text-shadow: 0 2px 10px #ff5324;
  padding: 1rem;
`

const subtitle = css`
  text-align: center;
  font-size: 1.8rem;
`

const btnWrapper = css`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`

const btnStyle = css`

`